import React from 'react';
import './style.css'; // Create this CSS file
import survey from  "../../Assets/Home/survey.png";
import secu from  "../../Assets/Home/secu.png";
import tech from  "../../Assets/Home/tech.png";
import team from  "../../Assets/Home/team.png";
import patrol from  "../../Assets/Home/patrol.png";
import covert from  "../../Assets/Home/covert.png";
import cons from  "../../Assets/Home/cons.png";
import alpr from  "../../Assets/Home/alpr.png";
import vms from  "../../Assets/Home/vms.png";
import all from  "../../Assets/Home/all.png";

const services = [
  { icon: survey, title: 'Remote Surveillance / 24 Hour Command Centre', description: '24/7 monitoring from our command centre.' },
  { icon: secu, title: ' Provision of Qualified & Trained Security Personnel', description: 'Trained, licensed officers for every need.' },
  { icon: tech, title: 'Technology Services', description: 'Advanced security tech integration.' },
  { icon: team, title: 'Emergency Response Team', description: 'Fast response to critical situations.' },
  { icon: patrol, title: 'Patrolling Officers', description: 'Regular mobile patrols for safety.' },
  { icon: covert, title: 'Covert & Resilient Team', description: 'Undercover and resilient operatives.' },
  { icon: cons, title: 'On-Site Consultation', description: 'Tailored security assessments.' },
  { icon: alpr, title: 'Automatic License Plate Recoginition (ALPR)', description: 'License plate scanning and tracking.' },
  { icon: vms, title: 'Visitor Management System (VMS)', description: 'Efficient check-in systems.' },
  { icon: all, title: 'Integrated Security Solutions Provider', description: 'End-to-end security strategies.' },
];

const ServicesCarousel = () => {
  return (
    <div className="carousel-wrapper">
      <div className="carousel" dir="rtl">
        
        {services.slice().reverse().map((service, index) => (
          <div className="card-carousel" key={index}>
             <img src={service.icon} alt="" className="service-image" />
            <h6 className="car-hea">{service.title}</h6>
        
          </div>
        ))}
      </div>    
    </div>
  );
};

export default ServicesCarousel;
